import * as React from 'react'
import Linkify from 'react-linkify'

import {
  Card,
  Typography as Text,
  Grid,
  Link,
  Box,
  Button,
} from '@material-ui/core'
import { logDashboardEvent } from '../../events'
import PolicyStyles from './policyStyles'
import { uiTextContent } from './data/policyParams'
import { trackWidgetClick } from '../../../../helpers/trackWidgetClick'
const ItemCard = ({ item, widgetId, dispatch }) => {
  const classes = PolicyStyles()

  const handleLinkClick = (title, link) => {
    trackWidgetClick(dispatch, 'Policy', title, { widgetId })
    if (widgetId && dispatch) {
      logDashboardEvent(dispatch, 'dashboardLinkEvent', widgetId, title, link)
      if (link) {
        window.open(link)
      }
    }
  }

  const linkDecorator = (href, text, key) => (
    <a href={href} key={key} target="_blank" rel="noopener noreferrer">
      {text}
    </a>
  )

  const EmptyDescription = () => (
    <Linkify componentDecorator={linkDecorator}>
      <Text variant="subtitle3" className={classes.descriptionText}>
        {uiTextContent.NO_DESCRIPTION}
      </Text>
    </Linkify>
  )
  return (
    <Card
      className={classes.announcementCardBackground}
      border={1}
      key={item.Id}
      variant="outlined"
    >
      <Grid container justifyContent="flex-start" direction="column">
        <Grid item>
          <Box className={classes.titleButtonContainer}>
            <Text variant="subtitle1">
              <Link
                href={item.URL}
                onClick={() => handleLinkClick(item.Title, item.URL)}
                target="_blank"
                rel="noopener noreferrer"
                color="primary"
              >
                {item.Title}
              </Link>
            </Text>
            {item.ReviewAndCommentLink && (
              <Button
                className={classes.titleButton}
                onClick={() =>
                  handleLinkClick(item.Title, item.ReviewAndCommentLink)
                }
              >
                {uiTextContent.ITEM_CARD_BUTTON_TEXT}
              </Button>
            )}
          </Box>
          <Box className={classes.announcementBody}>
            {item.Description ? (
              <Linkify componentDecorator={linkDecorator}>
                <Text variant="subtitle3" className={classes.descriptionText}>
                  {item.Description}
                </Text>
              </Linkify>
            ) : (
              <EmptyDescription />
            )}
          </Box>
        </Grid>
      </Grid>
    </Card>
  )
}

export default ItemCard
